module.exports = __webpack_public_path__ + "static/media/corpBanner4.f60f2c24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/corpBanner4.jpg
// module id = 361
// module chunks = 0